import { render, staticRenderFns } from "./ReviewContent.vue?vue&type=template&id=6f241cfe"
import script from "./ReviewContent.vue?vue&type=script&lang=js"
export * from "./ReviewContent.vue?vue&type=script&lang=js"
function injectStyles (context) {
  
  var style0 = require("./ReviewContent.vue?vue&type=style&index=0&id=6f241cfe&prod&lang=scss")
if (style0.__inject__) style0.__inject__(context)

}

/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  injectStyles,
  null,
  "2d8670bf"
  
)

export default component.exports